<template>
  <div class="feedback">
    <div class="title-default">
      <i class="goback" @click="$router.go(-1)">意见反馈</i> /
      <span>提交反馈</span>
    </div>
    <div class="feedback-content">
      <div class="two_label">
        <div class="type_name"><span class="xing">*</span>问题描述</div>
        <div class="type_content">
          <el-input
            v-model="value"
            placeholder="请输入问题描述"
            type="textarea"
          ></el-input>
        </div>
      </div>
      <div class="two_label feedback-upload">
        <div class="type_name">相关图片</div>
        <div class="type_content">
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            :fileList="fileList"
            @preview="handlePreview"
            @change="handleChange"
            :beforeUpload="beforeUpload"
          >
            <div v-if="fileList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </div>
      <el-button class="tijiao" @click="openSuccess()">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      previewVisible: false,
      previewImage: "",
      fileList: [],
      baseApl: process.env.VUE_APP_BASE_API
    };
  },

  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      if (fileList.length == 0) {
        this.fileList = fileList;
      } else {
        if (
          fileList[fileList.length - 1].type === "image/jpeg" ||
          fileList[fileList.length - 1].type === "image/png"
        ) {
          this.fileList = fileList;
        }
      }
    },
    // 判断上传是否为图片
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传png,或者jpg格式的图片");
        return reject(false)
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过5MB");
        return reject(false)
      }
      // return isJpgOrPng && isLt2M;
      return resolve(true)
      })
    },
    openSuccess() {
      this.$message.closeAll();
      var _this = this;
      if (this.value == "") {
        this.$message.error("请先输入反馈信息");
        return;
      }
      let imgs = [];
      for (let i of _this.fileList) {
        imgs.push({ url: i.response.data.url });
      }
      console.log(imgs);
      this.$post(`/user/api/feedback/add`, {
        content: _this.value,
        imgs: imgs
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success"
          });
          setTimeout(() => {
            this.$router.push({ path: "/user/feedback/success" });
          }, 1000);
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.feedback-content {
  .two_label {
    .type_content {
      textarea {
        width: 668px;
        height: 187px;
      }
      .ant-upload-list-picture-card {
        width: auto !important;
        flex: none;
        height: 80px;
        float: left;
      }
      .ant-upload-list-picture-card-container {
        width: 80px;
        height: 80px;
      }
      .ant-upload-list-picture-card .ant-upload-list-item {
        width: 80px;
        height: 80px;
        padding: 0;
      }
      .ant-upload.ant-upload-select-picture-card {
        width: 80px;
        height: 80px;
        border-radius: 2px;
      }
      .ant-upload.ant-upload-select-picture-card:hover {
        border-color: #3455d3;
        div {
          color: #3455d3;
        }
      }
      .ant-upload-list-item-info {
        width: 80px;
        height: 80px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.feedback {
  background: #ffffff;
  .title-default {
    color: #5e6066;
  }
  .feedback-content {
    margin-top: 16px;
    padding: 0 20px 24px 20px;
    .two_label {
      .type_name {
        color: #2f3133;
        font-size: 14px;
        margin-bottom: 16px;
      }
    }
    .feedback-upload {
      margin-top: 24px;
    }
    .tijiao {
      width: 129px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      color: #ffffff;
      padding: 0;
      margin-left: 539px;
      border-color: rgba(52, 85, 211, 1);
    }
  }
  .type_content {
    &/deep/.ant-upload-list-item-info > span {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
